import React from 'react';
export function usePointerDrag({ onDragStart, onDragMove, onDragEnd, onDragCancel }, mapEventToPoint, mapEventToStartPoint) {
    const startEventRef = React.useRef();
    const pointerMovedRef = React.useRef(false);
    React.useEffect(() => {
        const keyDownListener = (event) => {
            if (event.key === 'Escape' && startEventRef.current) {
                onDragCancel();
                startEventRef.current = undefined;
                pointerMovedRef.current = false;
            }
        };
        const blurListener = () => {
            if (startEventRef.current) {
                onDragCancel();
                startEventRef.current = undefined;
                pointerMovedRef.current = false;
            }
        };
        const visibilityChangeListener = () => {
            if (document.visibilityState === 'hidden' && startEventRef.current) {
                onDragCancel();
                startEventRef.current = undefined;
                pointerMovedRef.current = false;
            }
        };
        document.addEventListener('keydown', keyDownListener);
        document.addEventListener('blur', blurListener);
        document.addEventListener('visibilitychange', visibilityChangeListener);
        return () => {
            document.removeEventListener('keydown', keyDownListener);
            document.removeEventListener('blur', blurListener);
            document.removeEventListener('visibilitychange', visibilityChangeListener);
        };
    }, [onDragCancel]);
    return {
        onPointerDown: (event) => {
            var _a;
            if (!event.currentTarget.contains(event.target) ||
                event.target.closest('[data-tab-close-button]')) {
                return;
            }
            const tabPath = (_a = event.currentTarget.closest('[data-tab-path]')) === null || _a === void 0 ? void 0 : _a.dataset.tabPath;
            if (event.button === 0 && tabPath) {
                const point = mapEventToPoint(event);
                if (onDragStart(point, tabPath, event)) {
                    startEventRef.current = mapEventToStartPoint ? mapEventToStartPoint(event) : point;
                    event.stopPropagation();
                    event.preventDefault();
                    event.target.setPointerCapture(event.pointerId);
                }
            }
        },
        onPointerMove: (event) => {
            var _a;
            if (!event.currentTarget.contains(event.target)) {
                return;
            }
            const tabPath = (_a = event.currentTarget.closest('[data-tab-path]')) === null || _a === void 0 ? void 0 : _a.dataset.tabPath;
            if (startEventRef.current && tabPath) {
                onDragMove(mapEventToPoint(event, startEventRef.current), tabPath);
                pointerMovedRef.current = true;
                event.stopPropagation();
                event.preventDefault();
            }
        },
        onPointerUp: (event) => {
            var _a;
            if (!event.currentTarget.contains(event.target)) {
                return;
            }
            const tabPath = (_a = event.currentTarget.closest('[data-tab-path]')) === null || _a === void 0 ? void 0 : _a.dataset.tabPath;
            if (startEventRef.current && tabPath) {
                onDragEnd(mapEventToPoint(event, startEventRef.current), tabPath);
                startEventRef.current = undefined;
                pointerMovedRef.current = false;
                event.stopPropagation();
                event.preventDefault();
            }
        },
        onContextMenu: (event) => {
            if (!event.currentTarget.contains(event.target)) {
                return;
            }
            if (startEventRef.current) {
                onDragCancel();
                startEventRef.current = undefined;
                if (pointerMovedRef.current) {
                    pointerMovedRef.current = false;
                    event.stopPropagation();
                    event.preventDefault();
                }
                else {
                    event.stopPropagation();
                    event.preventDefault();
                }
            }
            else {
                event.stopPropagation();
                event.preventDefault();
            }
        },
    };
}
